export const partOptions = [
  'フルート',
  'ピッコロ',
  'クラリネット',
  'サクソフォン',
  'オーボエ',
  'ファゴット',
  'トランペット',
  'ホルン',
  'トランボーン',
  'ユーフォリアム',
  'チューバ',
  'パーカッション',
  'コントラバス',
  'ピアノ',
  '指揮',
  'その他',
];
